// constants
import { getBridgeSdk, NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";

/**
 * Function to handle SDK response for storage operations.
 * @param requestType - The type of storage operation (GET or DELETE).
 * @param timer - The timer interval to clear in case of an error.
 * @returns The response from the SDK storage operation.
 */
export const sdkResponse = async (requestType: STORAGE_TYPES, appStorageKey: string) => {
    try {
        const res = getBridgeSdk()?.storage({
            type: STORAGE_TYPES[requestType],
            data: {
                [appStorageKey]: "",
            },
        });
        return res;
    } catch (error) {
        if (error instanceof Error) {
            recordNREvent({ eventType: NEWRELIC_TABLES.FETCH_APP_STORAGE_DATA, error: error.message });
        }
    }
};
